import { useEffect, useRef } from 'react';

export function useSkipTransitionOnChange<T>(value: T): boolean {
  const prevRef = useRef<T>(value);
  const applyTransition = prevRef.current === value;

  useEffect(() => {
    prevRef.current = value;
  }, [value]);

  return applyTransition;
}
